import { narrativeFvModalReturnPath } from '@/components/NarrativeFairValue/components/NarrativeFairValueModal/utils';
import { ROUTE_PUBLIC_NARRATIVE_CREATE } from '@/constants/routes';
import { usePathname } from '@/hooks/location/usePathname';
import { getPath } from '@/router/utils';
import { useTracking } from 'react-tracking';
import { NARRATIVE_USER_POSITION } from '../utils/schema';
import { useCallback } from 'react';

type Props = {
  companyId: string | undefined | null;
  userHoldsPosition?: boolean;
};

export const useCreateNarrativeLink = ({
  companyId,
  userHoldsPosition,
}: Props) => {
  const pathname = usePathname();
  const { trackEvent } = useTracking();

  const handleClick = useCallback(() => {
    if (!companyId) return;

    trackEvent({
      action: 'click',
      target: 'create-narrative',
      modifier: 'create',
      companyId,
      valuationType: 'user_defined',
    });
  }, [trackEvent, companyId]);

  return {
    onClick: handleClick,
    href: companyId
      ? getPath({
          type: ROUTE_PUBLIC_NARRATIVE_CREATE,
          payload: {},
          query: {
            company: companyId,
            returnPath: narrativeFvModalReturnPath(pathname, companyId),
            ...(userHoldsPosition
              ? { position: NARRATIVE_USER_POSITION.HOLDS }
              : {}),
          },
        })
      : null,
  };
};
